/**
 * "Ver as N vendas" de uma pessoa num período (revisão 360, U5).
 *
 * A tela de lançamentos só respeita `de`/`ate` com `p=livre` — sem ele abria só HOJE — e recusa
 * `ate` no futuro (volta para os últimos 30 dias). Por isso o `ate` é cortado em hoje.
 */
export function linkDasVendas(pessoa: string, de: string, ate: string, hoje: string): string {
  const fim = ate > hoje ? hoje : ate;
  const inicio = de > fim ? fim : de;
  const q = new URLSearchParams({ pessoa, p: 'livre', de: inicio, ate: fim });
  return `#/lancamentos?${q.toString()}`;
}
